import { useQuery } from "@tanstack/react-query";

import { locationsApi } from "@/api/locations";
import { queryKeys } from "@/api/query-keys";
import { useOrgSelection } from "@/context/use-org-selection";

/**
 * Hydrated location tree for the selected Shadow org (zones + sensors nested).
 *
 * Disabled until an organization is selected — `X-Shadow-Org` would be empty.
 */
export const useMapLocations = () => {
	const { selected } = useOrgSelection();
	const orgCode = selected?.orgCode ?? null;
	const includeZonesAndSensors = true;

	const query = useQuery({
		enabled: orgCode !== null,
		queryFn: () => locationsApi.getLocations({ includeZonesAndSensors }),
		queryKey: queryKeys.locations.list(orgCode ?? "", {
			includeZonesAndSensors,
		}),
		staleTime: 2 * 60 * 1000,
	});

	return {
		...query,
		locations: query.data ?? [],
		orgCode,
	};
};

export type MapLocationsResult = ReturnType<typeof useMapLocations>;
